var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container calendar-list-container" },
    [
      _c(
        "basic-container",
        [
          _c(
            "avue-crud",
            {
              ref: "crud",
              attrs: {
                "before-open": _vm.onHandleBeforeOpen,
                data: _vm.list,
                option: _vm.tableOption,
                page: _vm.page,
                "table-loading": _vm.listLoading,
              },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "on-load": _vm.getList,
                "search-change": _vm.searchChange,
                "refresh-change": _vm.refreshChange,
                "size-change": _vm.sizeChange,
                "current-change": _vm.currentChange,
                "row-update": _vm.update,
                "row-save": _vm.create,
              },
              scopedSlots: _vm._u([
                {
                  key: "dsScopeForm",
                  fn: function (scope) {
                    return [
                      _vm.form.dsType == 1
                        ? _c(
                            "div",
                            [
                              _c("el-tree", {
                                ref: "scopeTree",
                                staticClass: "filter-tree",
                                attrs: {
                                  "check-strictly": true,
                                  data: _vm.dsScopeData,
                                  "default-checked-keys": _vm.checkedDsScope,
                                  props: _vm.defaultProps,
                                  "highlight-current": "",
                                  "node-key": "id",
                                  "show-checkbox": "",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "menu",
                  fn: function (scope) {
                    return [
                      _vm.roleManager_btn_edit
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-edit",
                                size: "small",
                                type: "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleUpdate(
                                    scope.row,
                                    scope.index
                                  )
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t编辑\n\t\t\t\t")]
                          )
                        : _vm._e(),
                      _vm.roleManager_btn_del
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-delete",
                                size: "small",
                                type: "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(
                                    scope.row,
                                    scope.index
                                  )
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t删除\n\t\t\t\t")]
                          )
                        : _vm._e(),
                      _vm.roleManager_btn_perm
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-plus",
                                size: "small",
                                type: "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handlePermission(
                                    scope.row,
                                    scope.index
                                  )
                                },
                              },
                            },
                            [_vm._v("\n\t\t\t\t\t权限\n\t\t\t\t")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.form,
                callback: function ($$v) {
                  _vm.form = $$v
                },
                expression: "form",
              },
            },
            [
              _c(
                "template",
                { slot: "menuLeft" },
                [
                  _vm.roleManager_btn_add
                    ? _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: { icon: "el-icon-edit", type: "primary" },
                          on: { click: _vm.handleCreate },
                        },
                        [_vm._v("\n\t\t\t\t\t添加\n\t\t\t\t")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.dialogPermissionVisible,
            title: "分配权限",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogPermissionVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-main-tree" },
            [
              _c("el-tree", {
                ref: "menuTree",
                staticClass: "filter-tree",
                attrs: {
                  "check-strictly": false,
                  data: _vm.treeData,
                  "default-checked-keys": _vm.checkedKeys,
                  "filter-node-method": _vm.filterNode,
                  props: _vm.defaultProps,
                  "default-expand-all": "",
                  "highlight-current": "",
                  "node-key": "id",
                  "show-checkbox": "",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.updatePermession(_vm.roleId)
                    },
                  },
                },
                [_vm._v("更 新")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "default" },
                  on: {
                    click: function ($event) {
                      return _vm.cancal()
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }